module.exports = __webpack_public_path__ + "static/img/gjzz.8f8de72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/gjzz.png
// module id = 58K/
// module chunks = 41